import { MouseEvent } from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import LowPriorityIcon from '@mui/icons-material/LowPriority';

export default ({ handleOpenDialog }: { handleOpenDialog: () => void }) => {
  const getBtnTitle = 'Reorder pages';

  const handleReorderPagesClick = (ev: MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();
    ev.stopPropagation();
    handleOpenDialog();
  };

  return (
    <>
      <Tooltip title={getBtnTitle} followCursor>
        <span>
          <IconButton
            aria-label={getBtnTitle}
            onClick={handleReorderPagesClick}
          >
            <LowPriorityIcon />
          </IconButton>
        </span>
      </Tooltip>
    </>
  );
};
